import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import { DownloadButton } from '@/features/import_export_histories/Table/Columns/Cells/components/DownloadButton';
import {
  ImportExportHistoriesColumn,
  OnDownloadClick,
} from '@/features/import_export_histories/type';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, memo, useCallback } from 'react';
import styles from '../column.module.scss';

type Props = {
  row: ImportExportHistoriesColumn;
  onDownloadClick?: OnDownloadClick;
};

const cx = classnames.bind(styles);

export const FileNameCell: FC<Props> = memo(({ row, onDownloadClick }) => {
  const { t } = useTranslation();
  const { id, name, can_download, type } = row;
  const hasNoFileName = (name ?? '') === '' || type === 'export';

  const handleDownloadClick = useCallback(async () => {
    await onDownloadClick?.(id, name ?? '');
  }, [onDownloadClick, id, name]);

  const showDownloadButton = type === 'import';

  return (
    <div className={cx('file-name-cell')}>
      {hasNoFileName ? (
        <span className={cx('file-name-no-text')}>--</span>
      ) : (
        <>
          <div className={cx('file-name-container')}>
            <FileNameSeparatorWithExtension>
              {name ?? ''}
            </FileNameSeparatorWithExtension>
          </div>
          <div className={cx('button-group')}>
            {showDownloadButton && (
              <DownloadButton
                onClick={handleDownloadClick}
                isDisabled={!can_download}
                tooltipTitle={
                  !can_download
                    ? t('import_export_history_download_expired')
                    : undefined
                }
              />
            )}
          </div>
        </>
      )}
    </div>
  );
});

FileNameCell.displayName = 'FileNameCell';
